import { TAB_PROPS, FIELD_PROPS, INNER_FIELD_PROPS } from '../constants'

/**
 * 递归合并字段配置与快照
 * @param {Array} fields - 字段配置
 * @param {Object|Array} fieldSnapshot - 字段快照 { key: { show, index, children } } 或 [key1, key2, ...]
 * @returns {Array} 合并后配置
 */
export function mergeFields(fields, fieldSnapshot, updateKeysMap = { show: FIELD_PROPS.SHOW }) {
  if (!fieldSnapshot) {
    return fields
  }

  // 解析快照（可能是字符串）
  let snapshot = typeof fieldSnapshot === 'string' ? JSON.parse(fieldSnapshot) : fieldSnapshot

  // 如果是数组字符串格式，转换为对象格式 { key: { show, index, children } }
  if (Array.isArray(snapshot) && snapshot.every(item => typeof item === 'string')) {
    let tempSnapshot = {}
    snapshot.forEach((key, index) => {
      tempSnapshot[key] = {
        show: true,
        index: index
      }
    })
    snapshot = tempSnapshot
  }

  // 1. 排序规则：show=true 的字段按 index 排序在前，不在快照中的字段保持原位置
  const snapshotKeys = Object.keys(snapshot)
  const sortedFields = fields.slice().sort((a, b) => {
    const aKey = a[FIELD_PROPS.KEY]
    const bKey = b[FIELD_PROPS.KEY]
    const aSnap = snapshot[aKey]
    const bSnap = snapshot[bKey]

    // 不在快照中的字段保持原位置
    if (!aSnap && !bSnap) return 0
    if (!aSnap) return 1
    if (!bSnap) return -1

    const aShow = aSnap.show !== undefined ? aSnap.show : true
    const bShow = bSnap.show !== undefined ? bSnap.show : true

    // show 状态不同：true 在前
    if (aShow && !bShow) return -1
    if (!aShow && bShow) return 1

    // 都显示：按快照中的顺序排序（index 或 keys 顺序）
    if (aShow && bShow) {
      const aIndex = aSnap.index !== undefined ? aSnap.index : snapshotKeys.indexOf(aKey)
      const bIndex = bSnap.index !== undefined ? bSnap.index : snapshotKeys.indexOf(bKey)
      return aIndex - bIndex
    }

    // 都隐藏：保持原有顺序
    return 0
  })

  // 2. 递归处理每个字段
  return sortedFields.map(field => {
    const key = field[FIELD_PROPS.KEY]
    const snap = snapshot[key]

    // 更新 show 状态
    field[updateKeysMap.show] = !!(snap && snap.show)

    // 递归处理子级（使用当前字段的 children 快照）
    const children = field[FIELD_PROPS.CHILD]
    if (Array.isArray(children) && children.length > 0 && snap && snap.children) {
      field[FIELD_PROPS.CHILD] = mergeFields(children, snap.children, updateKeysMap)
    }

    return field
  })
}

/**
 * 合并配置
 * @param {Array} items
 * @param {Array} configs
 * @returns {Array} 合并后配置
 */
export function mergeConfigs(items = [], configs = []) {
  return items.map(v => {
    const findItem = configs.find(conf => conf[TAB_PROPS.GENERIC_ID] === v[TAB_PROPS.GENERIC_ID])
    if (!findItem) {
      return v
    }
    return {
      ...v,
      [TAB_PROPS.FIELDS]: mergeFields(v[TAB_PROPS.FIELDS], findItem.fieldSnapshot, { show: INNER_FIELD_PROPS.SHOW })
    }
  })
}



// WEBPACK FOOTER //
// ./src/public/components/kye-field-settings/data/merge-configs.js